import NoteHistoryModal from './NoteHistoryModal.vue';

export default NoteHistoryModal;
